import axios from "axios";
import { BACKEND_BASEURL } from "../../../db/baseUrl";
export const API_UOM = `${BACKEND_BASEURL}api/unitOfMeasures/`;

const createUOM = async (name) => {
  const response = await axios.post(API_UOM + "createUOM", { name });
  return response.data;
};

const getAllUOMs = async () => {
  const response = await axios.get(API_UOM + "getAllUOMs");
  return response.data;
};

const updateUOM = async ({ id, name }) => {
  const response = await axios.patch(`${API_UOM}updateUOM/${id}`, { name });
  return response.data;
};

const deleteUOM = async (id) => {
  const response = await axios.delete(`${API_UOM}deleteUOM/${id}`);
  return response.data;
};

const UnitOfMeasureServices = { createUOM, getAllUOMs, updateUOM, deleteUOM };
export default UnitOfMeasureServices;
